import React from 'react'
import "./Main_wallet_cards_banner.css"
import Yellow_arrow_btn from '../../../../common_components/common_btn/yellow_arrow_btn/Yellow_arrow_btn'
import White_btn from '../../../../common_components/common_btn/white_btn/White_btn'
import Orange_btn from '../../../../common_components/common_btn/orange_btn/Orange_btn'
import { useNavigate } from 'react-router-dom'

function Main_wallet_cards_banner() {
    const navigate = useNavigate();
    return (
        <>
            <section className='Main_wallet_cards_banner'>
                <div className="row">
                    <div className="col-md-6">
                        <div className="text_hodler">
                            <h1>YOUR BALANCE</h1>
                            <p>View History</p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="count_holder">
                            <h1>₹ 4579031</h1>
                        </div>
                        <div className="btns_holder">
                            <Orange_btn btnText="Topup" />
                            <White_btn btnText="Withdraw" onClick={() => navigate("/main-wallet-withdrowal")} />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Main_wallet_cards_banner